// src/pages/SellerResetPassword.jsx
import React from "react";
import ResetPassword from "./ResetPassword";   // reuse seller reset password

export default function SellerResetPassword() {
  return <ResetPassword />;
}

